"use client"

import { Trash2 } from "lucide-react"
import { Button } from "@/components/ui/button"
import { clearAllLocalData } from "@/lib/breach/storage"

/** Wipes every incident, draft, and setting this site stored in this browser. Copies saved to an account are not touched. */
export function ClearAll({ size = "sm", className }: { size?: "sm" | "default"; className?: string }) {
  return (
    <Button type="button" variant="outline" size={size} className={`text-destructive print:hidden ${className ?? ""}`}
      onClick={() => {
        if (!confirm("Clear everything saved in this browser? This removes all incidents, answers, timeline entries, evidence, contacts and assignments stored on this device, and cannot be undone. Export a summary first if you need a copy. Copies saved to a signed-in account are not removed.")) return
        clearAllLocalData()
        window.location.href = "/start"
      }}>
      <Trash2 /> Clear everything
    </Button>
  )
}
